import React from 'react';
import { Modal, Spin, Button, Checkbox, message,Select } from 'antd';
import { hashHistory } from 'react-router'

import DataService from '../../lib/DataService';
import SharedTools from '../../lib/SharedTools';

import CurrentRoleStore from '../../stores/CurrentRoleStore';

import AttendanceCalendar from '../share/AttendanceCalendar';
import SetCalendarDateModal from '../share/SetCalendarDateModal';

import moment from 'moment';
import locale from 'antd/lib/date-picker/locale/zh_CN';

const CheckboxGroup = Checkbox.Group;
const Option = Select.Option;

export default class AttendanceSetCalendarPage extends React.Component {
  constructor(props) {
    super(props);
    let url = window.location.href;

    this.state = {
      gradeId: props.params.gradeId,
      schoolId: props.params.schoolId,
      semester: SharedTools.getCurrentSemester(),
      semesters:[],
      currentRole: CurrentRoleStore.getCurrentRole(),
      setAttendance: true,
      editAttendance: false,
      setTeacherAttendance: url.indexOf('teacher-attendance') >= 0 ? true : false,
      loading: false,
      days: [],
      submit_days: [],
      classGrades: [],
      checkedValues: [],
      showSetCalendarDate: false,
    }

    this.onChangeCheckbox = this.onChangeCheckbox.bind(this);
    this.submitAttendance = this.submitAttendance.bind(this);
    this.callbackDay = this.callbackDay.bind(this);

    // 设置日历的起始时间和结束时间
    this.changeCalendarDate = this.changeCalendarDate.bind(this);
    this.callBackCalendarDate = this.callBackCalendarDate.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  componentWillReceiveProps(newProps) {
    let setTeacherAttendance = window.location.href.indexOf('teacher-attendance') >= 0 ? true : false;
    if (setTeacherAttendance != this.state.setTeacherAttendance) {
      this.setState({
        setTeacherAttendance,
        gradeId: newProps.params.gradeId,
        setAttendance: true,
        editAttendance: false,
        loading: false,
        days: [],
        checkedValues: [],
        classGrades: []
      })
      this.getTeacherCalendar()
      if (!setTeacherAttendance) {
        this.getAllClassGrade()
      }
    }

  }

  componentDidMount() {
    this.getSchoolInfo()
    if (!this.state.setTeacherAttendance) {
      this.getAllClassGrade()
    }
  }

  getSchoolInfo() {
    DataService.getSchoolInfo(this.state.schoolId).then((res) => {
      let date = new Date().getTime();
      let semesters = res.calendar_semester, calendar_semester;
      let all_semesters = SharedTools.getAllSemesters(SharedTools.getCurrentSemester(),20171);
      all_semesters.forEach(s=>{
        let key = s.semester
        if(semesters[key]){
          let { start_year, start_month, start_day, end_year, end_month, end_day} = semesters[key];
          let start_date = new Date(start_year, Number(String(start_month - 1).padStart(2, '0')), Number(String(start_day).padStart(2, '0'))).getTime();
          let end_date = new Date(end_year, Number(String(end_month - 1).padStart(2, '0')), Number(String(end_day).padStart(2, '0'))).getTime();
          if (start_date <= date && date <= end_date) {
            calendar_semester = semesters[key];
            this.setState({
              semester: Number(key)
            })
          }
        }
        else{
          semesters[key] = null
        }
      })

      if (calendar_semester) {
        this.getTeacherCalendar()
        this.setState({
          startDate: calendar_semester.start_year + '-' + calendar_semester.start_month.toString().padStart(2, '0') + '-' + calendar_semester.start_day.toString().padStart(2, '0'),
          endDate: calendar_semester.end_year + '-' + calendar_semester.end_month.toString().padStart(2, '0') + '-' + calendar_semester.end_day.toString().padStart(2, '0'),
        })
      } else {
        this.setState({
          startDate: null,
          endDate: null,
        })
      }
      this.setState({
        semesters:semesters,
      })

    }).catch((error) => {
      console.log(error)
      this.setState({
        loading: false
      })
      message.error('获取日历失败，请重试！')
    });
  }

  getTeacherCalendar(grade_id,semester) {
    let data = {
      semester: semester? semester:this.state.semester
    }, { setTeacherAttendance } = this.state;
    if (setTeacherAttendance) {
      data.school_id = this.state.schoolId
    } else {
      data.grade_id = grade_id ? grade_id : this.state.gradeId;
    }
    this.setState({
      loading: true
    })
    console.log(data)
    DataService.getCalendars(data).then((res) => {
      this.setState({
        days: res,
        loading: false
      })
    }).catch((error) => {
      console.log(error)
      this.setState({
        loading: false
      })
      message.error('获取日历失败，请重试！')
    });
   
  }

  getAllClassGrade() {
    DataService.getAllClassGrade(this.state.schoolId).then((res) => {
      let classGrades = res.filter((grade) => !grade.is_graduated);
      let grade = classGrades.find((grade) => grade.id == this.state.gradeId)
      grade.selected = true;
      this.setState({
        classGrades
      })
    }).catch((error) => {
      console.log(error)
    });
  }

  selectGrade(gradeId) {
    let classGrades = this.state.classGrades;
    classGrades.map((grade) => {
      grade.selected = false
      if (grade.id == gradeId) {
        grade.selected = true
      }
    })

    this.getTeacherCalendar(gradeId)
    this.setState({
      classGrades,
      gradeId,
      checkedValues: []
    })
  }

  onChangeCheckbox(checkedValues) {
    this.setState({
      checkedValues
    })
  }

  changeEditStatus(editAttendance) {
    this.setState({
      editAttendance
    })
  }

  submitAttendance() {
    let data = {
      semester: this.state.semester,
    }, { setTeacherAttendance, submit_days, days } = this.state;
    if (setTeacherAttendance) {
      data.school_id = this.state.schoolId
      data.info = submit_days;
    } else {
      if (this.state.checkedValues.length > 0){
        let grade_ids = [this.state.gradeId];
        data.grade_ids = grade_ids.concat(this.state.checkedValues);
        data.info = []
        days.forEach((day) => {
          data.info.push({
            year: day.year,
            month: day.month,
            day: day.day,
            should_clock_on: day.should_clock_on
          })
        })
      } else {
        data.grade_id = this.state.gradeId
        data.info = submit_days;
      }
    }
    DataService.createCalendars(data).then((res) => {
      this.changeEditStatus(false)
      if(res.today_on){
        message.info('设置今天为考勤日，系统将于今天22:00获取相关考勤记录')
      }
      this.setState({
        submit_days: []
      })
      message.success('设置日历成功！')
    }).catch((error) => {
      console.log(error)
      message.error('设置日历失败！')
    });
  }

  callbackDay(year, month, day, should_clock_on) {
    let {days, submit_days} = this.state;
    let obj = days.find((item) => (item.year == year && item.month == month && item.day == day));
    if (obj) {
      obj.should_clock_on = !should_clock_on;
    } else {
      days.push({
        year,
        month,
        day,
        should_clock_on: true
      })
    }

    let index = submit_days.findIndex((item) => (item.year == year && item.month == month && item.day == day));
    if (index >= 0) {
      submit_days.splice(index, 1);
    } else {
      submit_days.push({
        year,
        month,
        day,
        should_clock_on: should_clock_on ? false : true
      })
    }
    this.setState({
      days,
      submit_days
    })
  }

  // 修改日历的起始时间和结束时间
  changeCalendarDate() {
    this.setState({
      showSetCalendarDate: true
    })
  }

  callBackCalendarDate(startDate, endDate) {
    this.setState({
      startDate,
      endDate
    })
  }

  closeModal() {
    this.setState({
      showSetCalendarDate: false
    })
  }

  getSemesterToString(semester) {
    var year = semester.toString().substring(0, 4);
    var number = semester.toString().substring(4, 5);
    var yearSub = parseInt(year.toString().substring(2, 4));
    return (number == '1' ? yearSub + '-' + (yearSub + 1) + '学年上学期' : yearSub + '-' + (yearSub + 1) + '学年下学期');
  }

  selectSemester(semester){
    let calendar_semester = this.state.semesters[semester];
    this.setState({
      semester:parseInt(semester)
    })
    if(calendar_semester){
      this.getTeacherCalendar(null,semester)
      this.setState({
        startDate: calendar_semester.start_year + '-' + calendar_semester.start_month.toString().padStart(2, '0') + '-' + calendar_semester.start_day.toString().padStart(2, '0'),
        endDate: calendar_semester.end_year + '-' + calendar_semester.end_month.toString().padStart(2, '0') + '-' + calendar_semester.end_day.toString().padStart(2, '0'),
      })
    }
    else {
      this.setState({
        startDate: null,
        endDate: null,
      })
    }
  }

  render() {
    const { setAttendance, editAttendance, setTeacherAttendance, days, classGrades, checkedValues, semester,semesters, loading, schoolId, startDate, endDate, showSetCalendarDate, currentRole } = this.state;
    const options = [], dayCount = days.filter((day) => day.should_clock_on).length;
    classGrades.forEach((grade) => {
      if (!grade.selected) {
        options.push({ label: grade.grade_name, value: grade.id})
      }
    })
    const isAdmin = currentRole.associatName == 'school' || currentRole.associatName == 'system';
    const choose_semesters = Object.keys(semesters).map(s => (
      <Option value={s.toString()} key={s.toString()}>{this.getSemesterToString(s)}</Option>
    ));

    return (
      <div className="student-attendance-calendar-grade-page">
        <div className="calendar-date-container">
        <div className="select-box">
          <label>选择学期：</label>
          <Select value={semester.toString()} onSelect={this.selectSemester.bind(this)} style={{ width: 120 }}>
            {choose_semesters}
          </Select>
        </div>
          {(startDate && endDate) ? <div>
            学期日历起始时间为：<span className="date-point">{startDate}</span>  结束时间为：<span className="date-point">{endDate}</span>
          </div> : (isAdmin ? <div>
            <span className="operation-calendar" onClick={this.changeCalendarDate}>设置当前学期日历时间</span>
            <SetCalendarDateModal showSetCalendarDate={showSetCalendarDate} callBackCalendarDate={this.callBackCalendarDate} closeModal={this.closeModal} schoolId={schoolId} semester={semester} startDate={startDate} endDate={endDate} />
          </div> : '请联系学校管理员设置日历开始和结束时间')}
        </div>
        {(startDate && endDate) ? <div>
          {setTeacherAttendance ? <div className="header-label">选择需要考勤的日期</div> : <div className="page-header">
            {classGrades.map((grade) => <div className={"grade-name" + (grade.selected ? " active" : "")} onClick={this.selectGrade.bind(this, grade.id)} key={grade.id}>{grade.grade_name}</div>)}
          </div>}
          <Spin spinning={loading} style={{ width: '520px' }}>
            <AttendanceCalendar startDate={startDate} endDate={endDate} setAttendance={setAttendance} editAttendance={editAttendance} callbackDay={this.callbackDay} days={days} />
          </Spin>
          <div className="operation-container">
            {editAttendance ? <Button type="primary" className="submit-btn" onClick={this.submitAttendance}><span className="submit-text">确认</span>(共{dayCount}天)</Button> : <span className="edit-btn" onClick={this.changeEditStatus.bind(this, true)}>修改</span>}
            {(editAttendance && !setTeacherAttendance && options.length > 0) ? <div className="synchronization-operation">
              <span>同步到: </span>
              <CheckboxGroup options={options} onChange={this.onChangeCheckbox} value={checkedValues} />
            </div> : ''}
          </div>
        </div> : ''}
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./app/javascript/bundles/WebPcApp/components/attendance/AttendanceSetCalendarPage.jsx